import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import NivelesListado from "../../components/Nivel/nivelesList";
import {
  sagaGetNiveles,
  saveNivel,
  sagaEliminarNivel,
  sagaGetNivelByNombre,
} from "../../reducers/nivelesReducer/actions";
import { nivelesDataSelector } from "../../selectors/nivelesSelector";
import { usuarioSelector } from "../../selectors/sessionSelector";
// import * as Notification from '../../components/Common/notification';

class NivelContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      descripcion: "",
      niveles: {},
      allNiveles: {},
      modalData: {
        openModal: false,
        mensaje: "Está por eliminar un nivel",
        labelModalOk: "Eliminar",
        handleModalOk: () => {},
        handleCloseModal: () => {},
      },
      usuarioCargado: false,
    };
    // busco los datos iniciales
    this.busqueda();
  }

  componentDidUpdate = (prevProps) => {
    if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
      this.setState({ usuarioCargado: true }, () => {
        if (this.props.usuario.idRol === 4) {
          window.location.hash = "/Pedidos";
        }
      });
    }

    if (prevProps.niveles.niveles !== this.props.niveles.niveles) {
      this.setState({
        allNiveles: this.props.niveles.niveles,
        niveles: this.props.niveles.niveles,
      });
    }
  };

  busqueda() {
    this.props.sagaGetNiveles(this.state.descripcion);
    this.props.saveNivel(undefined);
  }

  handleSearch = (descripcion) => {
    if (!descripcion || descripcion.trim() === "") {
      this.setState({ niveles: this.state.allNiveles });
    } else {
      const filteredNiveles = this.state.allNiveles.filter((nivel) =>
        nivel.descripcion.toLowerCase().includes(descripcion.toLowerCase())
      );
      this.setState({ descripcion, niveles: filteredNiveles });
    }
  };

  setModalData = (nivel) => {
    this.setState({
      modalData: {
        openModal: true,
        mensaje: `Está por eliminar el nivel ${nivel.descripcion}`,
        labelModalOk: "Eliminar",
        handleModalOk: () => {
          this.props.sagaEliminarNivel(nivel.id);
          this.setState({ modalData: { openModal: false } });
        },
        handleCloseModal: () => {
          this.setState({ modalData: { openModal: false } });
        },
      },
    });
  };

  render() {
    return (
      <NivelesListado
        niveles={this.state.niveles}
        mapToItem={(x) => ({
          nombre: x.descripcion,
          codigo: x.nroNivel,
          onClick: x
            ? () => {
                this.props.saveNivel(x);
                this.props.history.push("/Niveles/Edit/" + x.id);
              }
            : undefined,
          opciones: x
            ? [
                {
                  nombre: "Editar",
                  handler: () => {
                    this.props.saveNivel(x);
                    this.props.history.push("/Niveles/Edit/" + x.id);
                  },
                },
                {
                  nombre: "Eliminar",
                  handler: () => {
                    this.setModalData(x);
                  },
                },
              ]
            : [],
          imagen: x.imagen ? x.imagen : require("../../images/default_rubro.png"),
        })}
        handleOnSave={() => {}}
        handleOnSearch={this.handleSearch}
        {...this.state.modalData}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetNiveles,
      saveNivel,
      sagaEliminarNivel,
      sagaGetNivelByNombre,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    niveles: nivelesDataSelector(state),
    usuario: usuarioSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NivelContainer);
